<script setup lang="ts">
import * as Sentry from '@sentry/vue'
import { useUnleashContext } from '@unleash/proxy-client-vue'
import { watch } from 'vue'
import { RouterView } from 'vue-router'

import { config } from '@/lib/helpers'
import { useErrorNotification } from '@/lib/hooks/error-handling.hooks'
import { initializeBannedUserChannel } from '@/lib/services/banned-user.service'
import { router } from '@/router'
import { useUserStore } from '@/stores/user'
import { LoadingComponent } from '@/ui-library'

const updateContext = useUnleashContext()
const userStore = useUserStore()

useErrorNotification()

initializeBannedUserChannel(() => {
  void router.push({ name: 'no-access', query: { reason: 'banned' } })
})

// Should be moved to auth wrapper (and create it at first) in case of creation pages which doesn't require authentication
watch(
  () => userStore.user,
  async (user) => {
    if (user) {
      if (config.environment === 'production') {
        Sentry.setUser({ id: String(user.id) })
      }

      if (updateContext) {
        await updateContext({
          userId: String(user.id),
          properties: { userEmail: user.email, locale: user.locale },
        })
      }
    }
  },
)
</script>

<template>
  <template v-if="!userStore.isLoading">
    <RouterView />
  </template>
  <LoadingComponent v-else is-full-size :size="96" />
</template>
